import {handleLocalExternalIp} from "@js/globalFunctions/handleLocalExternalIp";

handleLocalExternalIp();
